module.exports = __webpack_public_path__ + "img/town-snow.ba1ff254.jpeg";